
<script>
	import listBase from '@_system/components/base/list.vue'
	import editIndex from './edit/index.vue'
	import staticIndex from './static/index.vue'
	export default {
		extends: listBase,
		name: 'inventorycostadjustIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<edit-index row={this.currentrow} ref="inventorycostadjustEditIndex" onSuccess={this.editSubmit} />,			
			]
			this.$slots.header = [
				<static-index sourcedata={this.sourcedata} moduleName={this.moduleName} ref="staticIndex" key={this.staticKey} />,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'inventorycostadjust',
				windowName: '成本调价',
				windowType: 'modal',
				currentrow:null,
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 2000, 5000, 10000],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			edit(row) {
				this.currentrow = row
				this.$refs.inventorycostadjustEditIndex.modal_show()
			},
			editSubmit(){
				this.$refs[this.moduleName + '_list'].commitProxy('query')
			},
			afterGet(){
				this.staticKey = Math.random()
			}
		},
		components: {
			editIndex,
			staticIndex
		}
	}
</script>
